export interface AccountProfile {
  name: string
  email: string
  organization: string
  role: string
}

function readStorage(key: string): string {
  if (typeof window === 'undefined') return ''
  return window.localStorage.getItem(key)?.trim() ?? ''
}

export function getAccountProfile(): AccountProfile {
  const email = readStorage('userEmail')
  const storedName = readStorage('userFirstName') || readStorage('userName')

  return {
    name: storedName || (email ? (email.split('@')[0] ?? 'User') : 'User'),
    email: email || 'Session integration pending',
    organization: readStorage('userOrganization'),
    role: readStorage('userRole') || 'User',
  }
}

export function clearLegacySession(): void {
  if (typeof window === 'undefined') return

  ;[
    'isLoggedIn',
    'userEmail',
    'userName',
    'userFirstName',
    'authToken',
    'pendingAuthEmail',
    'userRole',
    'userOrganization',
    'userOrganizationId',
    'forgesphere.session.profile',
    'forgesphere.session.status',
    'forgesphere.session.checkedAt',
  ].forEach((key) => window.localStorage.removeItem(key))
}

export function getInitials(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean)
  if (words.length === 0) return 'U'
  if (words.length === 1) return words[0]?.slice(0, 1).toUpperCase() ?? 'U'
  return `${words[0]?.[0] ?? ''}${words[1]?.[0] ?? ''}`.toUpperCase()
}
